import { api } from './client';

type Envelope<T> = { data: T };

export type FieldType =
  | 'signature' | 'initial' | 'date' | 'text'
  | 'checkbox' | 'radio' | 'dropdown'
  | 'name' | 'email' | 'company' | 'image' | 'number' | 'note';

export type FieldView = {
  id: string;
  documentId: string;
  recipientId: string;
  type: FieldType;
  pageNumber: number;
  posX: number;
  posY: number;
  width: number;
  height: number;
  isRequired: boolean;
  defaultValue: string | null;
  value: string | null;
  filledAt: string | null;
};

export type FieldInput = {
  documentId: string;
  recipientId: string;
  type: FieldType;
  pageNumber: number;
  posX: number;
  posY: number;
  width: number;
  height: number;
  isRequired?: boolean;
  defaultValue?: string;
};

export const fieldsApi = {
  async list(envelopeId: string): Promise<FieldView[]> {
    const { data } = await api.get<Envelope<FieldView[]>>(`/envelopes/${envelopeId}/fields`);
    return data.data;
  },

  /** Replaces all fields atomically. */
  async bulkSave(envelopeId: string, fields: FieldInput[]): Promise<FieldView[]> {
    const { data } = await api.put<Envelope<FieldView[]>>(
      `/envelopes/${envelopeId}/fields`,
      { fields },
    );
    return data.data;
  },

  async update(uuid: string, input: Partial<FieldInput>): Promise<FieldView> {
    const { data } = await api.patch<Envelope<FieldView>>(`/fields/${uuid}`, input);
    return data.data;
  },

  async remove(uuid: string): Promise<void> {
    await api.delete(`/fields/${uuid}`);
  },
};
